import styled from '@emotion/styled';

export const Container = styled.div`
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 32px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0;
`;

export const SubscriptionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 24px;
`;

export const InfoCard = styled.div`
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
`;

export const InfoLabel = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
`;

export const InfoValue = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PackageBadge = styled.span<{ packageType: string }>`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: ${(props) => {
        switch (props.packageType) {
            case 'ADVANCED':
                return '#6366f1';
            case 'STANDARD':
                return '#10b981';
            case 'NEW_PRACTITIONER':
                return '#f59e0b';
            case 'COMMUNITY_MEMBER':
                return '#3b82f6';
            case 'SPECIAL_PARTNER':
                return '#8b5cf6';
            default:
                return '#6b7280';
        }
    }};
    color: #ffffff;
`;

export const StatusBadge = styled.span<{ status: string }>`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: ${(props) => {
        switch (props.status) {
            case 'ACTIVE':
                return '#d1fae5';
            case 'PENDING_APPROVAL':
                return '#fef3c7';
            case 'SUSPENDED':
                return '#fee2e2';
            case 'CANCELLED':
                return '#e5e7eb';
            default:
                return '#f3f4f6';
        }
    }};
    color: ${(props) => {
        switch (props.status) {
            case 'ACTIVE':
                return '#065f46';
            case 'PENDING_APPROVAL':
                return '#92400e';
            case 'SUSPENDED':
                return '#991b1b';
            case 'CANCELLED':
                return '#374151';
            default:
                return '#6b7280';
        }
    }};
`;

export const BillingPeriodBadge = styled.span`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    background: #e0e7ff;
    color: #3730a3;
`;

export const AnnualDiscountBadge = styled.span`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    background: #d1fae5;
    color: #065f46;
`;

export const FreePeriodBadge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    background: #fef3c7;
    color: #92400e;
    border: 2px solid #fbbf24;
`;

export const StrikethroughPrice = styled.span`
    text-decoration: line-through;
    color: #9ca3af;
    font-size: 14px;
    margin-right: 8px;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

export const InfoMessage = styled.div<{ type: 'info' | 'warning' | 'success' }>`
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 14px;
    margin-bottom: 16px;
    background: ${(props) => {
        switch (props.type) {
            case 'info':
                return '#eff6ff';
            case 'warning':
                return '#fef3c7';
            case 'success':
                return '#d1fae5';
            default:
                return '#f3f4f6';
        }
    }};
    color: ${(props) => {
        switch (props.type) {
            case 'info':
                return '#1e40af';
            case 'warning':
                return '#92400e';
            case 'success':
                return '#065f46';
            default:
                return '#374151';
        }
    }};
    border: 1px solid
        ${(props) => {
            switch (props.type) {
                case 'info':
                    return '#bfdbfe';
                case 'warning':
                    return '#fbbf24';
                case 'success':
                    return '#6ee7b7';
                default:
                    return '#d1d5db';
            }
        }};
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #6b7280;
`;

export const EmptyStateTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
`;

export const EmptyStateText = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 24px;
`;
